module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-LightItalic.9f98bc7a.ttf";